import {gameName} from "./gameConfigsAndUrls";

export const RoutePaths = {
    game: `/${gameName}/game`,
    lobby:`/${gameName}/`,
    betShop: `/${gameName}/betshop`,
    replay: `/${gameName}/replay`,
};
